import React, { FC, ReactNode } from 'react';
import Skeleton from 'react-loading-skeleton';
import { cx } from '@emotion/css';

import { productCategoryAndDriveType } from '@phoenix/team-m/my-tool-shed/frontend/util/master-data';
import { ProductDetails, ProductListItem } from '@phoenix/team-m/my-tool-shed/frontend/util/product/product.model';

interface ToolInfoProps {
  product?: ProductListItem | ProductDetails;
  isLoading?: boolean;
  customNameClassName?: string;
  customContainerClasses?: string;
  children?: ReactNode;
}

export const ToolInfo: FC<React.PropsWithChildren<ToolInfoProps>> = ({
  product = {} as ProductDetails,
  isLoading = false,
  customNameClassName,
  customContainerClasses = 'grid gap-y-2 self-start',
  children,
}) => {
  return (
    <div className={customContainerClasses}>
      {(isLoading || product['brand']?.name) && (
        <span className="stihl-text-body-default-bold">{isLoading ? <Skeleton /> : product['brand']?.name}</span>
      )}
      <span className="stihl-text-body-default-reg" data-testid="productCategoryAndDriveType">
        {isLoading ? <Skeleton /> : productCategoryAndDriveType(product)}
      </span>
      {(isLoading || product['customName']) && (
        <span className={cx(customNameClassName, 'stihl-text-h4-mobile')} data-testid="productNickname">
          {isLoading ? <Skeleton /> : product['customName']}
        </span>
      )}
      <span className="stihl-text-body-default-reg" data-testid="productName">
        {isLoading ? <Skeleton /> : product.productName}
      </span>
      {children}
    </div>
  );
};
